export const EXPAND_SHORTLINK = 'EXPAND_SHORTLINK';
export const EXPAND_SHORTLINK_DONE = 'EXPAND_SHORTLINK_DONE';
export const EXPAND_SHORTLINK_ERROR = 'EXPAND_SHORTLINK_ERROR';
export const RESET_SHORTLINK = 'RESET_SHORTLINK';
//# sourceMappingURL=actionTypes.js.map